import * as React from 'react';

import Grid from '@material-ui/core/Grid';

import CustomerEntry from '../customer-entry/customer-entry';
import LicenseTable from '../license-table/license-table';

const Customer = () => {
  return (
    <div>
      <Grid container spacing={16}>
        <Grid item xs={12} md={6}>
          <CustomerEntry />
        </Grid>
        <Grid item xs={12} md={6}>
          <LicenseTable />
        </Grid>
      </Grid>
    </div>
  );
}

export default Customer;


// WEBPACK FOOTER //
// ./src/features/customer/customer.tsx